import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("acp_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("acp_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const loginWith = useCallback((token, userObj) => {
    localStorage.setItem("acp_token", token);
    setUser(userObj);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("acp_token");
    setUser(false);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      return res.data;
    } catch {
      return null;
    }
  }, []);

  const value = useMemo(() => ({ user, ready, loginWith, logout, refresh }),
    [user, ready, loginWith, logout, refresh]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
